import { mediaCredits, professor } from "../data";
import { ExternalLink, PageIntro } from "../components/Shell";

export default function ContactPage() {
  return (
    <>
      <PageIntro
        label="Contact"
        title="연락처"
        aside={
          <>
            Yonsei School of Business
            <br />
            Marketing
          </>
        }
      />
      <section className="page-section shell">
        <div className="contact-layout">
          <dl className="contact-card">
            <div className="contact-line">
              <dt>Professor</dt>
              <dd>{professor.name} · {professor.nameEn}</dd>
            </div>
            <div className="contact-line">
              <dt>Email</dt>
              <dd>
                <a href={`mailto:${professor.email}`}>{professor.email}</a>
              </dd>
            </div>
            <div className="contact-line">
              <dt>Telephone</dt>
              <dd>{professor.telephone}</dd>
            </div>
            <div className="contact-line">
              <dt>Office</dt>
              <dd>{professor.office}</dd>
            </div>
            <div className="contact-line">
              <dt>Profile</dt>
              <dd>
                <ExternalLink href={professor.officialProfileUrl}>
                  연세대학교 경영대학
                </ExternalLink>
              </dd>
            </div>
          </dl>
          <figure className="contact-photo">
            <img
              src="/media/yonsei-campus-wide.jpg"
              alt="연세대학교 캠퍼스 전경"
              width="1920"
              height="1080"
              loading="lazy"
            />
            <figcaption className="photo-credit">
              사진: Christian Bolz · Wikimedia Commons · CC BY-SA 4.0
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="page-section is-white" aria-labelledby="sources-heading">
        <div className="shell">
          <div className="section-header">
            <div>
              <p className="section-label">Sources · Rights</p>
              <h2 id="sources-heading">자료 출처와 이용 안내</h2>
            </div>
          </div>
          <dl className="source-list">
            <div className="source-item">
              <dt>교수·연구 실적</dt>
              <dd>
                연세대학교 경영대학 공식 교수 프로필과 DOI 원문 정보를 기준으로
                정리했습니다. 최종 공개 전 교수 확인이 필요합니다.
              </dd>
            </div>
            <div className="source-item">
              <dt>연구 도식</dt>
              <dd>
                Weathering the digital shift 도식은 Li, Choi &amp; Kim (2026)의 Figure
                1을 CC BY 4.0 조건에 따라 재작도했습니다. 다른 도식은 논문 초록과
                공개된 연구정보를 바탕으로 새로 구성했으며 출판사 원본 그림을
                복제하지 않았습니다.
              </dd>
            </div>
            <div className="source-item">
              <dt>프로필 사진</dt>
              <dd>
                연세대학교 경영대학 공식 교수진 페이지 사진입니다. 현재 검토용 시안에만
                사용하며 최종 공개 전 사용 승인을 확인합니다.
              </dd>
            </div>
            {mediaCredits
              .filter((media) => media.license)
              .map((media) => (
                <div className="source-item" key={media.id}>
                  <dt>{media.alt}</dt>
                  <dd>
                    {media.author} · {media.license} ·{" "}
                    <a
                      className="external-link"
                      href={media.sourceUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      원본
                      <span aria-hidden="true">↗</span>
                    </a>
                  </dd>
                </div>
              ))}
          </dl>
        </div>
      </section>
    </>
  );
}
